module.exports = __webpack_public_path__ + "img/国防科技大学计算机学院.7d792564.png";